import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const cookieInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<any> => {
  // Clone the request and set withCredentials to true
  const modifiedReq = req.clone({
    withCredentials: true,
    headers: req.headers.set('X-Requested-With', 'XMLHttpRequest')
  });

  return next(modifiedReq).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        // Handle response cookies if needed
        const setCookieHeader = event.headers.get('set-cookie');
        if (setCookieHeader) {
          // Handle the cookie value if needed
          console.log('Received cookie:', setCookieHeader);
        }
      }
      return event;
    })
  );
};
